/* eslint-disable global-require */
import * as React from 'react';
import styled from '@emotion/styled';
import { tokens, Button as RawButton } from '@hotjar/hotsauce';
import { Card as RawCard } from '@hotjar/webapp/components/Card';

const Card = styled(RawCard)`
  display: flex;
  align-items: center;
  padding: ${tokens.spacer.x2};
`;

const Button = styled(RawButton)`
  margin-left: ${tokens.spacer.x3};
`;

const Img = styled.img`
  width: 254px;
  height: 140px;
  margin-right: ${tokens.spacer.x3};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 900px;
`;

const Title = styled.span`
  ${tokens.text('subtitle1')};
  margin-bottom: ${tokens.spacer.x1};
`;

const Text = styled.span`
  ${tokens.text('body2')}
`;

interface EmptyStateCardProps {
  img: string;
  title: string;
  children: React.ReactNode;
  buttonText?: string;
  onClick?: () => void;
}

export const EmptyStateCard = ({
  img,
  title,
  onClick,
  buttonText,
  children,
}: EmptyStateCardProps): JSX.Element => {
  return (
    <Card>
      {img && <Img src={img} />}
      <Content>
        <Title>{title}</Title>
        <Text>{children}</Text>
      </Content>
      {onClick && buttonText && <Button onClick={onClick}>{buttonText}</Button>}
    </Card>
  );
};
